document.addEventListener('click', function (event) {
  var img = event.target.closest('.js-lightbox img, .lightbox-gallery img');
  if (!img) return;
  event.preventDefault();

  var overlay = document.createElement('div');
  overlay.className = 'lb-overlay';
  overlay.innerHTML =
    '<button class="lb-close" aria-label="Schließen">&times;</button>' +
    '<img src="' + (img.currentSrc || img.src) + '" alt="' + (img.alt || '') + '">';
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  function close() {
    overlay.remove();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  overlay.addEventListener('click', close);
  document.addEventListener('keydown', onKey);
});
